module.exports = __webpack_public_path__ + "static/media/search-product-performance-ranking.694dfb50.png";